import Main from './pages/main.js'

function App() {
  return (
    <Main></Main>
  );
}

export default App;